<footer>
    <div class="container-fluid">
        <p class="copyright">REH ICO Crypto © 2023 All Rights Reserved.<strong class="theme-text-color"></strong>
        </p>
    </div>
</footer>